<template>
<div></div>
</template>

<script>
export default {
  name: "FAQ-page",
  data() {
    return {
      selectedTab:0,
      filters: [
        {
          id: 1,
          title: 'Customer Success Center'
        },
        {
          id: 2,
          title: 'Innovations'
        },
        {
          id: 3,
          title: 'Our factory'
        },
        {
          id: 4,
          title: 'About Ardakan'
        },
        {
          id: 5,
          title: 'Virtual visit'
        },
      ],
    }
  }
}
</script>

<style scoped>
.faq-header{
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 200px;
  background: #f2c303 url("../../../assets/images/sunburst.png");
}
.faq-header-bottom-border {
  position: absolute;
  bottom: -22px;
  width: 100%;
}
.tab-item {
  cursor: pointer;
  height: 60px;
  width: 99%;
  font-weight: bold;
  font-size: 14px;
  margin:8px 2px;
  background: #3b393a;
  color: #f2c303;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.selected-tab{
  cursor: pointer;
  height: 60px;
  width: 99%;
  font-weight: bold;
  font-size: 14px;
  margin:8px 2px;
  background: #f2c303;
  color: #3b393a;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.selected-tab:hover{
  background: #f2c303;
  color: #3b393a;
}
.tab-item:hover{
  background: #1a1719;
}
</style>